// extracted by mini-css-extract-plugin
export default {"container":"vTcHmSDw","skeleton":"czec7iO5"};